import React, { useState, useRef } from 'react';
import { IconButton, CircularProgress, styled } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import axios, { AxiosResponse } from 'axios';
import { getAccessToken } from 'auth/service';
import { Image } from 'models';

const StyledLink = styled('a')({
    display: 'none'
});

const Spinner = styled('div')({
    position: 'absolute'
});

export default function DownloadImageButton(props: { image: Image }) {
    const [loading, setLoading] = useState<boolean>(false);
    const anchor = useRef<HTMLAnchorElement>(null);

    const handleClick = () => {
        if (!anchor.current) {
            console.error('cannot start download because there is no anchor tag to facilitate it');
            return;
        }

        setLoading(true);
        getAccessToken()
            .then(accessToken => {
                const instance = axios.create({
                    headers: {
                        Authorization: 'Bearer ' + accessToken
                    }
                });
                instance
                    .get(`/api/image/${props.image.id}/download`, { responseType: 'arraybuffer' })
                    .then((response: AxiosResponse<ArrayBuffer>) => {
                        if (anchor.current) {
                            const file = new Blob([response.data], { type: 'image/jpeg' });
                            const url = window.URL.createObjectURL(file);
                            anchor.current.href = url;
                            anchor.current.download = props.image.fileName;
                            anchor.current.click();
                            window.URL.revokeObjectURL(url);
                        }
                        setLoading(false);
                    })
                    .catch(err => {
                        console.error(err);
                        setLoading(false);
                    });
            });
    };

    return (
        <IconButton onClick={handleClick} disabled={loading}>
            <StyledLink ref={anchor}></StyledLink>
            {loading && <Spinner>
                <CircularProgress />
            </Spinner>}
            <FileDownloadOutlinedIcon />
        </IconButton>
    );
}